import React, { useEffect, useRef, useState } from 'react';
import ApiService from '@/services';
import { CmsPageContentIdentifier } from '@/types/fitting-hardware';

export interface CompendiumLoaderProps {
  serviceUrl: string
}

const CompendiumLoader = ({ serviceUrl } : CompendiumLoaderProps) => {
  const apiService = new ApiService(serviceUrl);

  const [styleSnippet, setStyleSnippet] = useState<string>('');
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(
    () => {
      apiService.getCmsSnippetSet('compendium')
        .then((result) => setStyleSnippet((result as any)[CmsPageContentIdentifier.Compendium]))
        .catch(console.error);

      if (ref.current) {
        (window as any).webapp.initializePlugins(ref.current.parentNode);
      }
    },
    [],
  );

  return (
    <span ref={ref} dangerouslySetInnerHTML={{ __html: styleSnippet }} />
  );
};

export default CompendiumLoader;
